import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import Chip from '@material-ui/core/Chip';
import Colors from '../../internal-components/Colors';
import Select from 'react-select';
import styled from 'styled-components/macro';
import Tooltip from '@material-ui/core/Tooltip';
import useTranslations from '../../hooks/useTranslations';

const StyledChip = styled(Chip)`
  margin: 1px;
`;
const StyledSelect = styled(Select)`
  .select__control {
    box-shadow: none !important;
    min-height: 44px;
  }
  .select__control--is-focused {
    border-color: ${Colors.PRIMARY} !important;
  }
`;

const MultiValue = props => {
  return (
    <Tooltip
      title='Send form to this user'
    >
      <StyledChip
        tabIndex={-1}
        label={props.children}
        onDelete={props.data.status ? null : props.removeProps.onClick}
        deleteIcon={<CancelIcon {...props.removeProps} />}
        color={props.data.status ? 'default' : 'primary'}
      />
    </Tooltip>
  );
};

const components = {
  MultiValue
};

const EmailsInputFromListView = props => {
  const t = useTranslations();
  return (
    <div>
      <StyledSelect
        components={components}
        defaultValue={[]}
        value={props.value}
        isMulti
        name="users"
        onChange={props.onChange}
        options={props.options}
        className="basic-multi-select"
        classNamePrefix="select"
        noOptionsMessage={() => t('entries.forms.requestNoShared')}
      />
    </div>
  );
};

export default EmailsInputFromListView;
